module.exports = __webpack_public_path__ + "static/sb-e889f60f808d199b644c2146a15ce616.png";